module.exports = __webpack_public_path__ + "img/img_tutorial_04.e39c8c01.svg";